import { motion } from 'framer-motion';

const MissionVision = () => {
  return (
    <section className="py-16 bg-secondary-50 dark:bg-secondary-900">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <motion.div 
            className="bg-white dark:bg-secondary-800 rounded-lg shadow-lg p-8"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <div className="text-primary-600 dark:text-primary-400 text-4xl mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold mb-4 text-secondary-900 dark:text-white">Our Mission</h2>
            <p className="text-secondary-600 dark:text-secondary-300 mb-4">
              To revolutionize global logistics through innovative technology, sustainable practices, and unwavering reliability, enabling businesses of all sizes to connect seamlessly with their customers worldwide.
            </p>
            <p className="text-secondary-600 dark:text-secondary-300">
              We strive to be the backbone of global commerce, ensuring that distance is never a barrier to business growth and customer satisfaction.
            </p>
          </motion.div>
          
          <motion.div 
            className="bg-white dark:bg-secondary-800 rounded-lg shadow-lg p-8"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <div className="text-primary-600 dark:text-primary-400 text-4xl mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold mb-4 text-secondary-900 dark:text-white">Our Vision</h2>
            <p className="text-secondary-600 dark:text-secondary-300 mb-4">
              To be the world's most trusted logistics partner, known for our commitment to excellence, innovation, and sustainability in every shipment we handle.
            </p>
            <p className="text-secondary-600 dark:text-secondary-300">
              We envision a future where logistics is not just about moving goods, but about creating meaningful connections between businesses and their customers through reliable, efficient, and environmentally responsible supply chain solutions.
            </p>
          </motion.div>
        </div>
        
        <motion.div 
          className="mt-12 bg-white dark:bg-secondary-800 rounded-lg shadow-lg p-8"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <div className="text-primary-600 dark:text-primary-400 text-4xl mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold mb-4 text-secondary-900 dark:text-white">Our Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <h3 className="text-lg font-semibold mb-2 text-secondary-900 dark:text-white">Reliability</h3>
              <p className="text-secondary-600 dark:text-secondary-300">
                We deliver on our promises, ensuring that every shipment reaches its destination safely and on time.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-2 text-secondary-900 dark:text-white">Innovation</h3>
              <p className="text-secondary-600 dark:text-secondary-300">
                We continuously seek new technologies and methods to improve our services and stay ahead of industry trends.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-2 text-secondary-900 dark:text-white">Sustainability</h3>
              <p className="text-secondary-600 dark:text-secondary-300">
                We are committed to reducing our environmental footprint and promoting eco-friendly logistics solutions.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MissionVision;